import Vue from "vue";
import { Api } from "../plugins/api";
import axios from "axios";

//Vue.prototype.$moment = moment;
Vue.config.productionTip = false;

// Mise en place d'axios
axios.defaults.baseURL = process.env.VUE_APP_BASE_API_URL;
Vue.prototype.$http = axios;
//Vue.use(require('vue-moment'));

Vue.prototype.$storeCatalogue = {
  // Stockage des valeurs catalogue
  Pays: [], // DescId = 303
  Civilite: [],
  Genre: [],
  Province: [],
  Region: [],
  Diplomes: [],
  DiplomesPostBac: [],
  DiplomesMaster: [],
  DepartementFrance: [],
  RegionFrance: [],
  NatureHandicap: [],
  DisciplineSportive: [],
  TypeBac: [],
  FiliereBac: [],
  FiliereBacAffiche: [],
  AnneeScolaire: [],
  AnneeCpge: [],
  AnneeCpge2eAnnee: [],
  TypeEtablissement: [],
  Filiere: [],
  Filiere2eAnnee: [],
  ConcoursFr: [],
  ConcoursMa: [],
  EcoleFr: [],
  EcoleMa: [],
  AdmissibleOral: [],
  OuiNon: [],
  Parente: [],
  StatutParentTuteur: [],
  TypeOrganisme: [],
  SituationPro: [],
  SituationFamilial: [],
  Secteur: [],
  Fonction: [],
  EcoleFrAffiche: [],
  EcoleMaAffiche: [],
  Conformite: [],
  NomDocument :[],
  ConnaissanceFirsi: [],
  StatutParentTuteurAffiche: [],
  EtatAnnee: [],
  Duree: [],
  FraisScolaritePrisEnCharge: [],
  SouhaiteBourse: [],
  Programme: [],
  EcolesGef: [],
  EcolesGem: [],
  NomBourse: [],
  TypeAnnee: [],
  RelationTuteur: [],
  BaremBac: [],
  SpecialiteBac: [],
  Specialite1Bac: [],
  Specialite2Bac: [],
  MathsExpertOption: [],
  DiplomeActuel: [],
  TypeEtablissementPublicPrive: [],
  DomaineBac: [],
  DomaineBacFr: [],
  VilleMaroc: [],
  VilleMarocMaster: [],
  EtablissementMarocMaster: [],
  EtablissementMaroc: [],
  FiliereIng: [],
  EtesVous: [],
  ChargeParent: [],
  SituationParent: [],
  VousEtes: [],
  TypeFinancement: [],
  NatureBien: [],
  ChoixCycle: [],
  NbCompteBancaire: [],
  SituationFamiliale: [],
  SystemeNotationBac: [],
  SystemeNotationPostBac: [],
  AnneeScolaireBac:[],

  // Liste des DescId utilisés dans le formulaire
  DescIdPays: 303,
  DescIdProgramme: 7312,
  DescIdCivilite: 204,
  DescIdGenre: 246,
  DescIdProvince: 7403,
  DescIdRegion: 7404,
  DescIdNatureHandicap: 7316,
  DescIdDisciplineSportive: 13554,
  DescIdTypeBac: 7324,
  DescIdFiliereBac: 7336,
  DescIdAnneeScolaire: 7102,
  DescIdAnneeCpge: 8008,
  DescIdTypeEtablissement: 347,
  DescIdFiliere: 358,
  DescIdConcoursFr: 8303,
  DescIdConcoursMa: 8305,
  DescIdEcoleFr: 8304,
  DescIdEcoleMa: 8306,
  DescIdAdmissibleOral: 8308,
  DescIdOuiNon: 7332,
  DescIdParente: 8102,
  DescIdStatutParentTuteur: 8112,
  DescIdTypeOrganisme: 8108,
  DescIdSituationPro: 8103,
  DescIdSecteur: 8105,
  DescIdFonction: 413,
  DescIdDepartementFrance: 10004,
  DescIdRegionFrance: 10003,
  DescIdConformite: 9107,
  DescIdNomDocument:9103,
  DescIdConnaissanceFirsi: 14628,
  DescIdConnaissanceUm6p: 13512,
  DescIdEtatAnnee: 7114,
  DescIdSouhaiteBourse: 7130,
  DescIdDuree: 9807,
  DescIdPriseEnCharge: 7155,
  DescIdTypeAnnee: 7152,
  DescIdNomBourse: 7128,
  DescIdNiveauEtude: 13905,
  DescIdRelationTuteur: 13606,
  DescIdBaremBac: 13723,
  DescIdSpecialiteBac: 13725,
  DescIdMathsExpertOption: 13727,
  DescIdDiplomeActuel: 14302,
  DescIdTypeEtablissementPublicPrive: 13716,
  DescIdDomaineBac: 13719,
  DescIdEtesVous: 14040,
  DescIdChargeParent: 14041,
  DescIdSituationParent: 14042,
  DescIdSituationFamiliale: 14029,
  DescIdVousEtes: 14045,
  DescIdTypeFinancement: 14705,
  DescIdNatureBien: 14713,
  DescIdChoixCycle: 13515,
  DescIdNbCompteBancaire: 14610,
  DescIdSystemeNotationBac: 13747,
  DescIdSystemeNotationPostBac: 14346,

  // Liste des dataId utilisés dans le formulaire
  ProgrammeGefDataId: 4096,
  ProgrammeGemDataId: 4097,
  SituationProActif: 4002,
  SituationProNonActif: 4003,
  SituationProRetraite: 4004,
  SecteurSalarie: 4005,
  SecteurFonctionnaire: 4006,
  SecteurLiberale: 4007,
  SecteurAutoEntrepreneur: 4236,
  SecteurAgricole: 5036,
  SecteurInformel: 4132,
  SituationFamDivorce: 3997,
  SituationFamDivorceRemarie: 5315,
  SituationFamDecede: 3996,
  SituationFamMarie: 3995,
  SituationFamVeuf: 3994,

  DataIdStage: [4446, 4447],
  DataIdAlternance: [4472, 4473],
  DataIdContratProfessionnel: [4470],
  DatatIdFilieresNonMaroc: [4950, 4952, 4978],

  DataId: {
    SituationProRetraiteActif:5578,
    PropositionAdmission: 4272,
    Oui: 4008,
    Non: 4009,
    AdmisOralOui: 4099,
    Maroc: 1002134,
    France: 1002072,
    NonConforme: 4251,
    Conforme: 4250,
    NouveauDocument: 4299,
    AnnexeAVerifier: 4410,
    AutreBac: 4119,
    AutreFiliere: 3907,
    AutreFiliereBac: 4962,
    ParenteTuteur: 3993,
    ParenteMere: 3992,
    ParentePere: 3991,
    TypeOrganismePrive: 3905,
    TypeOrganismePublic: 3906,
    TypeBacFrancais: 3687,
    TypeBacMarocain: 3866,
    TypeBacAutre: 4119,
    BrouillonCandidat: 3643,
    PremiereAnneeCpge: 4113,
    Redouble1ereAnneeCpge: 4116,
    DigitalYear: 4474,
    AutreBourse: 4712,
    EtatDossierBoursePremiereAnnee: 4434,
    EtatDossierBrouillon: 4464,
    EtatDossierEnAttenteComplement: 4511,
    EquivalentScientifique: 4967,
    AucunType: 4754,
    StageType: 4789,
    AlternanceType: 4788,
    ContratProType: 4790,
    Ingenierie: 4864,
    Master: 4844,
    PostBac: 4843,
    ClusterSante:4862,
    ProgrammeIngenieur: 4845,
    ProgrammeParallele:5354,
    ProgrammeParalleleBac1:5425,
    BaremBac20: 4906,
    BaremBacAutre: 4908,
    PrepaScientifique: 4964,
    PrepaGrandeEcole: 4965,
    BacPlus1: 5424,
    BacPlus2: 4963,
    BacPlus3: 4933,
    BacPlus4: 4934,
    BacPlus5: 4935,
    BacPlus6: 4936,
    BacLettres: 4978,
    ChargeUnParentDivorce: 4886,
    ChargeUnParentVeuf: 4887,
    ChargeDeuxParentsMaries: 4885,
    ChargeTuteur: 4888,
    ChargeSansTuteur: 4889,
    VousEtesEtudiant: 5016,
    TypeRevenuPropriete: 5020,
    TypeRevenuCredit: 5019,
    PersonneConcerneeCandidat: 5024,
    PersonneConcerneeMere: 5022,
    PersonneConcerneePere: 5021,
    PersonneConcerneeTuteur: 5023,
    SpecialiteAutre: 5007,
    AutreRevenu: 5047,
    CyclePostBac: 5067,
    CycleMasterInge: 5068,
    DeuxiemeAnneeCpge: 4114,
    GardeMere: 4891,
    GardePere: 4890,
    TutelleMere: 4893,
    TutellePere: 4892,
    MereRemarieOui: 4896,
    MereRemarieNon: 4897,
    Document2emeTranche: 5612,
    Document3emeTranche: 5613,
    PereRemarieOui: 4894,
    PereRemarieNon: 4895,
    InscriptionR1: 4816,
    InscriptionR2: 4820,
    InscriptionComplementSoumis: 4819,
    InscriptionIncomplete: 4815,
    CandidatureBourseFirsiSoumis: 4874,
    ConnaissanceFirsiAutre: 4417,
    SystemeNotationPostBacSemestriel: 5334,
    InscriptionComplementDossier: 4818,
    AttestationRibMarroc: 4726,
    AttestationRibFrance: 4732,
  },

  // ------------- Fonctions du store catalogue

  // retourne le lang00 correspondant à l'id pour un catalogue
  AffichageCatalogue(catalogue, id, langue) {
    let valeur = catalogue.find((i) => i.id == id);
    if (valeur) {
      return valeur[langue];
    }

    return "";
  },

  // retourne le libelle des valeurs catalogue sélectionnés.
  AffichageCatalogueMultiple(catalogue, valeurs, langue) {
    var affichage = "";
    if (valeurs) {
      valeurs.forEach((element) => {
        affichage += this.AffichageCatalogue(catalogue, element, langue) + "; ";
      });
    }

    return affichage;
  },

  // Retourne le parentId correspondant à l'id pour un catalogue.
  GetParentId(catalogue, id) {
    return catalogue.find((i) => i.id == id)?.parentId;
  },

  // Retourne la liste filtrer par code.
  GetByCode(catalogue, code) {
    let list = catalogue;
    list = list.filter((i) => {
      return i.code == code;
    });
    return list;
  },

  // Retourne la liste filtrée par parent
  GetByParentId(catalogue, parentId) {
    let list = catalogue;
    list = list.filter((i) => {
      return i.parentId == parentId;
    });
    return list;
  },

  // Fonction qui appelle l'api pour récupérer les valeurs catalogue
  GetFileData(descid, asc) {
    return Api.get(`filedata/getList/` + descid + "/" + asc);
  },

  // Fonction qui appelle l'api pour récupérer les villes marocaines sous forme de  catalogue
  GetVilleMarocFileData() {
    return Api.get(`filedata/ListeVilles`).then((response) => {
      // Succès
      if (response.data) {
        this.VilleMaroc = response.data;
      }
    });
  },

  // Fonction qui appelle l'api pour récupérer les etablissements marocains sous forme de  catalogue
  GetEtablissementsMarocFileData(ville) {
    return Api.get(`filedata/ListeEtablissement/` + ville).then((response) => {
      // Succès
      if (response.data) {
        this.EtablissementMaroc = response.data;
      }
    });
  },

  // Fonction qui appelle l'api pour récupérer les villes marocaines sous forme de  catalogue
  GetVilleMarocMasterFileData() {
    return Api.get(`filedata/ListeVilles`).then((response) => {
      // Succès
      if (response.data) {
        this.VilleMarocMaster = response.data;
      }
    });
  },

  // Fonction qui appelle l'api pour récupérer les etablissements marocains sous forme de  catalogue
  GetEtablissementsMarocMasterFileData(ville) {
    return Api.get(`filedata/ListeEtablissement/` + ville).then((response) => {
      // Succès
      if (response.data) {
        this.EtablissementMarocMaster = response.data;
      }
    });
  },

  ChargerCataloguesAnnexes() {
    // Conformité physique et électronique
    this.GetFileData(this.DescIdConformite, true).then((response) => {
      // Succès
      if (response.data) {
        this.Conformite = response.data;
      }
    });
    this.GetFileData(this.DescIdNomDocument, true).then((response) => {
      // Succès
      if (response.data) {
        this.NomDocument = response.data;
      }
    });
  },

  ChargerCataloguesConcours() {
    // Concours FR
    this.GetFileData(this.DescIdConcoursFr, true).then((response) => {
      // Succès
      if (response.data) {
        this.ConcoursFr = response.data;
      }
    });

    // concours MA
    this.GetFileData(this.DescIdConcoursMa, true).then((response) => {
      // Succès
      if (response.data) {
        this.ConcoursMa = response.data;
      }
    });

    // Ecole FR
    this.GetFileData(this.DescIdEcoleFr, true).then((response) => {
      // Succès
      if (response.data) {
        this.EcoleFr = response.data;
      }
    });

    // Ecole MA
    this.GetFileData(this.DescIdEcoleMa, true).then((response) => {
      // Succès
      if (response.data) {
        this.EcoleMa = response.data;
      }
    });

    // Admissible Oral
    this.GetFileData(this.DescIdAdmissibleOral, true).then((response) => {
      // Succès
      if (response.data) {
        this.AdmissibleOral = response.data;
      }
    });

    // Oui non
    this.GetFileData(this.DescIdOuiNon, false).then((response) => {
      // Succès
      if (response.data) {
        this.OuiNon = response.data;
      }
    });
  },
  DynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      /* next line works with strings and numbers,
       * and you may want to customize it to your needs
       */
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  },

  // Charge les catalogues du formulaire Candidature Bourse
  ChargerCataloguesCandidatureBourse() {
    // Pays
    Api.get("filedata/ListePays").then((response) => {
      // Succès
      if (response.data) {
        this.Pays = response.data;
      }
    });

    // Type de financement
    this.GetFileData(this.DescIdTypeFinancement, true).then((response) => {
      if (response.data) {
        this.TypeFinancement = response.data;
      }
    });

    // Nature du bien
    this.GetFileData(this.DescIdNatureBien, true).then((response) => {
      if (response.data) {
        this.NatureBien = response.data;
      }
    });
    // nombre de compte bancaire
    this.GetFileData(this.DescIdNbCompteBancaire, true).then((response) => {
      if (response.data) {
        this.NbCompteBancaire = response.data.sort(this.DynamicSort("code"));
      }
    });
    // Etes vous
    this.GetFileData(this.DescIdEtesVous, true).then((response) => {
      if (response.data) {
        this.EtesVous = response.data;
      }
    });
    // ChargeParent
    this.GetFileData(this.DescIdChargeParent, true).then((response) => {
      if (response.data) {
        this.ChargeParent = response.data;
      }
    });
    // Situation parent
    this.GetFileData(this.DescIdSituationParent, true).then((response) => {
      if (response.data) {
        this.SituationParent = response.data;
      }
    });
    // Vous etes
    this.GetFileData(this.DescIdVousEtes, true).then((response) => {
      if (response.data) {
        this.VousEtes = response.data;
      }
    });

    // connaissance firsi
    this.GetFileData(this.DescIdConnaissanceFirsi, true).then((response) => {
      if (response.data) {
        this.ConnaissanceFirsi = response.data.sort(this.DynamicSort("code"));
      }
    });

    // Civilite
    this.GetFileData(this.DescIdCivilite, true).then((response) => {
      // Succès
      if (response.data) {
        this.Civilite = response.data;
      }
    });

    // Genre
    this.GetFileData(this.DescIdGenre, true).then((response) => {
      // Succès
      if (response.data) {
        this.Genre = response.data;
      }
    });

    // Province
    this.GetFileData(this.DescIdProvince, true).then((response) => {
      // Succès
      if (response.data) {
        this.Province = response.data;
      }
    });

    // Region
    this.GetFileData(this.DescIdRegion, true).then((response) => {
      // Succès
      if (response.data) {
        this.Region = response.data;
      }
    });

    // Situation handicap
    this.GetFileData(this.DescIdNatureHandicap, true).then((response) => {
      // Succès
      if (response.data) {
        this.NatureHandicap = response.data;
      }
    });

    // Type BAC
    this.GetFileData(this.DescIdTypeBac, true).then((response) => {
      // Succès
      if (response.data) {
        this.TypeBac = response.data;
      }
    });

    // Filiere BAC
    this.GetFileData(this.DescIdFiliereBac, true).then((response) => {
      // Succès
      if (response.data) {
        this.FiliereBac = response.data;
        this.FiliereBacAffiche = response.data;
      }
    });

    // Annee scolaire
    this.GetFileData(this.DescIdAnneeScolaire, false).then((response) => {
      // Succès
      if (response.data) {
        this.AnneeScolaire = response.data;
      }
    });

    // Année CPGE
    this.GetFileData(this.DescIdAnneeCpge, false).then((response) => {
      // Succès
      if (response.data) {
        this.AnneeCpge = response.data;
        this.AnneeCpge2eAnnee = response.data.filter((e) => {
          return e.id == 4114 || e.id == 4115;
        });
      }
    });

    // type etablissement
    this.GetFileData(this.DescIdTypeEtablissement, true).then((response) => {
      // Succès
      if (response.data) {
        this.TypeEtablissement = response.data;
      }
    });

    // Filiere
    this.GetFileData(this.DescIdFiliere, true).then((response) => {
      // Succès
      if (response.data) {
        response.data.forEach((element) => {
          var valeur = {
            id: element.id,
            lang00: element.lang00 + " " + element.code,
          };

          this.Filiere.push(valeur);
          if (element.code.includes("2")) {
            this.Filiere2eAnnee.push(valeur);
          }
        });
      }
    });

    // Concours FR
    this.GetFileData(this.DescIdConcoursFr, true).then((response) => {
      // Succès
      if (response.data) {
        this.ConcoursFr = response.data;
      }
    });

    // concours MA
    this.GetFileData(this.DescIdConcoursMa, true).then((response) => {
      // Succès
      if (response.data) {
        this.ConcoursMa = response.data;
      }
    });

    // Ecole FR
    this.GetFileData(this.DescIdEcoleFr, true).then((response) => {
      // Succès
      if (response.data) {
        this.EcoleFr = response.data;
      }
    });

    // Ecole MA
    this.GetFileData(this.DescIdEcoleMa, true).then((response) => {
      // Succès
      if (response.data) {
        this.EcoleMa = response.data;
      }
    });

    // Admissible Oral
    this.GetFileData(this.DescIdAdmissibleOral, true).then((response) => {
      // Succès
      if (response.data) {
        this.AdmissibleOral = response.data;
      }
    });

    // Oui non
    this.GetFileData(this.DescIdOuiNon, false).then((response) => {
      // Succès
      if (response.data) {
        this.OuiNon = response.data;
      }
    });

    // parente
    this.GetFileData(this.DescIdParente, true).then((response) => {
      // Succès
      if (response.data) {
        this.Parente = response.data;
      }
    });

    // Situation familiale
    this.GetFileData(this.DescIdStatutParentTuteur, true).then((response) => {
      // Succès
      if (response.data) {
        this.StatutParentTuteur = response.data;
        this.StatutParentTuteurAffiche = response.data;
      }
    });

    // Type organisme
    this.GetFileData(this.DescIdTypeOrganisme, true).then((response) => {
      // Succès
      if (response.data) {
        this.TypeOrganisme = response.data;
      }
    });

    // Situation pro
    this.GetFileData(this.DescIdSituationPro, true).then((response) => {
      // Succès
      if (response.data) {
        this.SituationPro = response.data;
      }
    });

    // Secteur
    this.GetFileData(this.DescIdSecteur, true).then((response) => {
      // Succès
      if (response.data) {
        this.Secteur = response.data;
      }
    });

    // Fonction
    this.GetFileData(this.DescIdFonction, true).then((response) => {
      // Succès
      if (response.data) {
        this.Fonction = response.data;
      }
    });

    // Departement
    this.GetFileData(this.DescIdDepartementFrance, true).then((response) => {
      // Succès
      if (response.data) {
        this.DepartementFrance = response.data;
      }
    });

    // Region
    this.GetFileData(this.DescIdRegionFrance, true).then((response) => {
      // Succès
      if (response.data) {
        this.RegionFrance = response.data;
      }
    });
  },

  ChargerCataloguesDossierBourse() {
    // Pays
    Api.get("filedata/ListePays").then((response) => {
      if (response.data) {
        this.Pays = response.data;
      }
    });

    // Type année
    this.GetFileData(this.DescIdTypeAnnee, true).then((response) => {
      if (response.data) {
        this.TypeAnnee = response.data;
      }
    });

    // Nom bourse
    this.GetFileData(this.DescIdNomBourse, true).then((response) => {
      if (response.data) {
        this.NomBourse = response.data;
      }
    });
    // Genre
    this.GetFileData(this.DescIdGenre, true).then((response) => {
      if (response.data) {
        this.Genre = response.data;
      }
    });

    // Province
    this.GetFileData(this.DescIdProvince, true).then((response) => {
      if (response.data) {
        this.Province = response.data;
      }
    });

    // Region
    this.GetFileData(this.DescIdRegion, true).then((response) => {
      if (response.data) {
        this.Region = response.data;
      }
    });
    // Annee scolaire
    this.GetFileData(this.DescIdAnneeScolaire, false).then((response) => {
      if (response.data) {
        this.AnneeScolaire = response.data;
      }
    });

    // Oui non
    this.GetFileData(this.DescIdOuiNon, false).then((response) => {
      if (response.data) {
        this.OuiNon = response.data;
      }
    });
    // Departement
    this.GetFileData(this.DescIdDepartementFrance, true).then((response) => {
      if (response.data) {
        this.DepartementFrance = response.data;
      }
    });

    // Region
    this.GetFileData(this.DescIdRegionFrance, true).then((response) => {
      if (response.data) {
        this.RegionFrance = response.data;
      }
    });
    // Etat
    this.GetFileData(this.DescIdEtatAnnee, true).then((response) => {
      if (response.data) {
        this.EtatAnnee = response.data;
      }
    });
    // Souhaite la bourse
    this.GetFileData(this.DescIdSouhaiteBourse, true).then((response) => {
      if (response.data) {
        this.SouhaiteBourse = response.data;
      }
    });
    // Durée
    this.GetFileData(this.DescIdDuree, true).then((response) => {
      if (response.data) {
        this.Duree = response.data.sort(this.DynamicSort("code"));
      }
    });
    // Prise en charge
    this.GetFileData(this.DescIdPriseEnCharge, true).then((response) => {
      if (response.data) {
        this.FraisScolaritePrisEnCharge = response.data;
      }
    });

    // Programme
    this.GetFileData(this.DescIdProgramme, true).then((response) => {
      if (response.data) {
        this.Programme = response.data;
      }
    });
  },

  ChargerListeAnneeBac(anneeScolaire){
    // AnneeScolaireBac
    Api.get("um6p/ListeAnneesBac/"+anneeScolaire).then((response) => {
      if (response.data) {
        this.AnneeScolaireBac = response.data;
      }
    });
  },

  async ChargerCataloguesInscriptionUniversite() {
    // Pays
    const paysresponse = await Api.get("filedata/ListePays");
    if(paysresponse.data){
      this.Pays = paysresponse.data;
    }

    // Choix cycle
    const choixCycleReponse = await this.GetFileData(this.DescIdChoixCycle, true);
    if(choixCycleReponse){
      this.ChoixCycle = choixCycleReponse.data;
    }


    // Genre
    const genreReponse = await 
    this.GetFileData(this.DescIdGenre, true);
    
    if(genreReponse){
      this.Genre = genreReponse.data;
    }

    // Oui non
    const ouiNonReponse = await
    this.GetFileData(this.DescIdOuiNon, false);
    
    if(ouiNonReponse){
      this.OuiNon = ouiNonReponse.data;
    }

    // Situation handicap
    const situationReponse = await this.GetFileData(this.DescIdNatureHandicap, true);
    if(situationReponse){
      this.NatureHandicap = situationReponse.data;
    }
    
    // Discipline sportive
    const discipline = await 
    this.GetFileData(this.DescIdDisciplineSportive, true);
    if(discipline){
      this.DisciplineSportive = discipline.data;
    }

    // Type BAC
    const typeBac = await this.GetFileData(this.DescIdTypeBac, true);
    if(typeBac){
      this.TypeBac = typeBac.data.sort((a, b) => {
        return b.lang00.localeCompare(a.lang00);
      });
    }
    
    // Filiere BAC
    const filiere = await 
    this.GetFileData(this.DescIdDomaineBac, true);
    if(filiere){
      this.DomaineBac = filiere.data;
      // Trier la liste
      this.DomaineBacFr.sort((a, b) => {
        // Mettre les éléments avec code = null en premier
        if (a.code === null) return -1;
        if (b.code === null) return 1;

        // Mettre l'élément avec code = 2 en dernier
        if (a.code === 2) return 1;
        if (b.code === 2) return -1;

        // Mettre les éléments avec code = "FR" avant les autres
        if (a.code === "FR") return -1;
        if (b.code === "FR") return 1;

        // Ajouter des conditions pour les autres valeurs de code
        // Vous pouvez personnaliser cette logique en fonction de vos besoins
        if (a.code < b.code) return -1;
        if (a.code > b.code) return 1;

        // Si les codes sont égaux, conserver l'ordre existant
        return 0;
      });
      this.FiliereBacAffiche = filiere.data;
    }
    
    const domaineBac = await 
    this.GetFileData(this.DescIdDomaineBac, true);
    if(domaineBac){
        this.DomaineBacFr = domaineBac.data;

        // Trier la liste
        this.DomaineBacFr.sort((a, b) => {
          // Mettre les éléments avec code = null en premier
          if (a.code === null) return -1;
          if (b.code === null) return 1;

          // Mettre l'élément avec code = 2 en dernier
          if (a.code === 2) return 1;
          if (b.code === 2) return -1;

          // Mettre les éléments avec code = "FR" avant les autres
          if (a.code === "FR") return -1;
          if (b.code === "FR") return 1;

          // Ajouter des conditions pour les autres valeurs de code
          // Vous pouvez personnaliser cette logique en fonction de vos besoins
          if (a.code < b.code) return -1;
          if (a.code > b.code) return 1;

          // Si les codes sont égaux, conserver l'ordre existant
          return 0;
        });

        // Assigner la liste triée à FiliereBacAffiche
        this.FiliereBacAffiche = this.DomaineBacFr;
      }
    
    // Filiere ING + Diplome actuel
    const filiereIng = await 
    this.GetFileData(this.DescIdDiplomeActuel, true);
    if(filiereIng){
        this.FiliereIng = filiereIng.data.sort((a, b) => {
          return a.lang00.localeCompare(b.lang00);
        });
        this.FiliereBacAffiche = filiereIng.data;
    }
    
    // Diplome actuel
    const diplomeActuel = await 
    this.GetFileData(this.DescIdDiplomeActuel, false);
    if(diplomeActuel){
      this.DiplomeActuel = diplomeActuel.data;
    }

    // connaissance firsi
    const connaissanceFirsi = await 
    this.GetFileData(this.DescIdConnaissanceUm6p, true);
    if(connaissanceFirsi){
        this.ConnaissanceFirsi = connaissanceFirsi.data.sort(this.DynamicSort("code"));

    }
    
    // Province
    const province = await
    this.GetFileData(this.DescIdProvince, true);
    if(province){
      this.Province = province.data;
    }

    // type etablissement
    const typeEtab = await
    this.GetFileData(this.DescIdTypeEtablissementPublicPrive, true);
    if(typeEtab){
      this.TypeEtablissementPublicPrive = typeEtab.data;
    }

    // Situation familiale
    const situationFamiliale = await 
    this.GetFileData(this.DescIdStatutParentTuteur, true);
    if(situationFamiliale){
      this.StatutParentTuteur = situationFamiliale.data;
      this.StatutParentTuteur = this.StatutParentTuteur.filter(
          (obj) => obj.id !== this.SituationFamDecede
      );
      this.StatutParentTuteurAffiche = situationFamiliale.data;
    }


    // Region
    const region = await
    this.GetFileData(this.DescIdRegion, true);
    if(region){
      this.Region = region.data;
    }

    // Diplomes
    const diplome = await 
    this.GetFileData(this.DescIdNiveauEtude, true);
    if(diplome){
      // Tri du tableau par la propriété "code"
      this.Diplomes = diplome.data.sort((a, b) => {
        // Utilisation de localeCompare pour le tri alphabétique
        return a.code.localeCompare(b.code);
      });
      this.DiplomesPostBac = this.GetByCode(this.Diplomes, "1");
      this.DiplomesMaster = this.GetByCode(this.Diplomes, "2");
      let diplomeInge = this.GetByCode(this.Diplomes, "3");
      diplomeInge.forEach((filedata) => {
        this.DiplomesMaster.push(filedata);
      });
    }

    // Relation Tuteur.
    const relationTuteur = await 
    this.GetFileData(this.DescIdRelationTuteur, true);
    if(relationTuteur){
      this.RelationTuteur = relationTuteur.data;
    }
    // Annee scolaire

    const anneeEnCours = new Date().getFullYear();
    const anneeScolaire = await
    this.GetFileData(this.DescIdAnneeScolaire, false);
    if(anneeScolaire && anneeScolaire.status === 200){
      this.AnneeScolaire = anneeScolaire.data.filter(
        (obj) => parseInt(obj.code) <= anneeEnCours + 1
      );
    }
    else{
      console.error(
        "Erreur dans les codes du catalogue année qui ne sont pas numérique "
      );
    }

    // Barem Bac
    const baremBac = await 
    this.GetFileData(this.DescIdBaremBac, false);
    if(baremBac){
        this.BaremBac = baremBac.data;
    }

    // Specialite  Bac
    const specialitesBac = await 
    this.GetFileData(this.DescIdSpecialiteBac, false);
    if(specialitesBac){
      this.SpecialiteBac = specialitesBac.data;
      this.Specialite1Bac = specialitesBac.data;
      this.Specialite2Bac = specialitesBac.data;
    }

    // Math option
    const mathOption = await 
    this.GetFileData(this.DescIdMathsExpertOption, false);
    if(mathOption){
      this.MathsExpertOption = mathOption.data;
    }

    // Système Notation Bac.
    const systemeNotationBac = await 
    this.GetFileData(this.DescIdSystemeNotationBac, false);
    if(systemeNotationBac){
      this.SystemeNotationBac = systemeNotationBac.data.sort(this.DynamicSort("code"));
    }

    // Système Notation Post Bac.
    const systemeNotationPostBac = await 
    this.GetFileData(this.DescIdSystemeNotationPostBac, false);
    if(systemeNotationPostBac){
      this.SystemeNotationPostBac = systemeNotationPostBac.data.sort(
        this.DynamicSort("code")
      );
    }
  },

  PersonneConcerne(parente) {
    if (parente) {
      if (parente == this.DataId.ParenteMere) {
        return this.DataId.PersonneConcerneeMere;
      }
      if (parente == this.DataId.ParentePere) {
        return this.DataId.PersonneConcerneePere;
      }
      if (parente == this.DataId.ParenteTuteur) {
        return this.DataId.PersonneConcerneeTuteur;
      }
    }
    return null;
  },
  ChargerCatalogueCandidatureBourseFirsi() {
    // OuiNon
    this.GetFileData(this.DescIdOuiNon, false).then((response) => {
      // Succès
      if (response.data) {
        this.OuiNon = response.data;
      }
    });

    // Type organisme
    this.GetFileData(this.DescIdTypeOrganisme, true).then((response) => {
      // Succès
      if (response.data) {
        this.TypeOrganisme = response.data;
      }
    });

    // Fonction
    this.GetFileData(this.DescIdFonction, true).then((response) => {
      // Succès
      if (response.data) {
        this.Fonction = response.data;
      }
    });

    // Genre
    this.GetFileData(this.DescIdGenre, true).then((response) => {
      // Succès
      if (response.data) {
        this.Genre = response.data;
      }
    });

    // Pays
    Api.get("filedata/ListePays").then((response) => {
      // Succès
      if (response.data) {
        this.Pays = response.data;
      }
    });

    // Situation familiale
    this.GetFileData(this.DescIdStatutParentTuteur, true).then((response) => {
      // Succès
      if (response.data) {
        this.StatutParentTuteur = response.data;
        this.StatutParentTuteurAffiche = response.data;
      }
    });

    // Nature du handicap
    this.GetFileData(this.DescIdNatureHandicap, true).then((response) => {
      // Succès
      if (response.data) {
        this.NatureHandicap = response.data;
      }
    });

    // Province
    this.GetFileData(this.DescIdProvince, true).then((response) => {
      // Succès
      if (response.data) {
        this.Province = response.data;
      }
    });

    // region
    this.GetFileData(this.DescIdRegion, true).then((response) => {
      // Succès
      if (response.data) {
        this.Region = response.data;
      }
    });

    // Departement
    this.GetFileData(this.DescIdDepartementFrance, true).then((response) => {
      // Succès
      if (response.data) {
        this.DepartementFrance = response.data;
      }
    });

    // Region
    this.GetFileData(this.DescIdRegionFrance, true).then((response) => {
      // Succès
      if (response.data) {
        this.RegionFrance = response.data;
      }
    });

    // etes vous
    this.GetFileData(this.DescIdEtesVous, true).then((response) => {
      if (response.data) {
        this.EtesVous = response.data;
      }
    });

    // Charge parent
    this.GetFileData(this.DescIdChargeParent, true).then((response) => {
      if (response.data) {
        this.ChargeParent = response.data;
      }
    });
    // Parent tuteur veuf/divorce
    this.GetFileData(this.DescIdSituationParent, true).then((response) => {
      if (response.data) {
        this.SituationParent = response.data;
      }
    });
    // vous etes
    this.GetFileData(this.DescIdVousEtes, true).then((response) => {
      if (response.data) {
        this.VousEtes = response.data;
      }
    });

    // connaissance firsi
    this.GetFileData(this.DescIdConnaissanceFirsi, true).then((response) => {
      if (response.data) {
        this.ConnaissanceFirsi = response.data.sort(this.DynamicSort("code"));
      }
    });

    // nb compte bancaire
    this.GetFileData(this.DescIdNbCompteBancaire, true).then((response) => {
      if (response.data) {
        this.NbCompteBancaire = response.data.sort(this.DynamicSort("code"));
      }
    });
    // Civilité
    this.GetFileData(this.DescIdCivilite, true).then((response) => {
      // Succès
      if (response.data) {
        this.Civilite = response.data;
      }
    });

    // lien parental
    this.GetFileData(this.DescIdParente, true).then((response) => {
      // Succès
      if (response.data) {
        this.Parente = response.data;
      }
    });
    // etat professionnel
    this.GetFileData(this.DescIdSecteur, true).then((response) => {
      // Succès
      if (response.data) {
        this.Secteur = response.data;
      }
    });

    // Situation pro
    this.GetFileData(this.DescIdSituationPro, true).then((response) => {
      // Succès
      if (response.data) {
        this.SituationPro = response.data;
      }
    });
    // type financement
    this.GetFileData(this.DescIdTypeFinancement, true).then((response) => {
      if (response.data) {
        this.TypeFinancement = response.data;
      }
    });
    // nature du bien
    this.GetFileData(this.DescIdNatureBien, true).then((response) => {
      if (response.data) {
        this.NatureBien = response.data;
      }
    });
    // Situation familiale
    this.GetFileData(this.DescIdSituationFamiliale, true).then((response) => {
      if (response.data) {
        this.SituationFamiliale = response.data;
      }
    });
  },
  ChargerCatalogueCandidatureBourseEcoleCentrale(){
    
    // Pays
    Api.get("filedata/ListePays").then((response) => {
      // Succès
      if (response.data) {
        this.Pays = response.data;
      }
    });

    // Autres catalogues
    // OuiNon
    this.GetFileData(this.DescIdOuiNon, false).then((response) => {
      // Succès
      if (response.data) {
        this.OuiNon = response.data;
      }
    });

    // Type organisme
    this.GetFileData(this.DescIdTypeOrganisme, true).then((response) => {
      // Succès
      if (response.data) {
        this.TypeOrganisme = response.data;
      }
    });

    // Fonction
    this.GetFileData(this.DescIdFonction, true).then((response) => {
      // Succès
      if (response.data) {
        this.Fonction = response.data;
      }
    });

    // Genre
    this.GetFileData(this.DescIdGenre, true).then((response) => {
      // Succès
      if (response.data) {
        this.Genre = response.data;
      }
    });
    // Situation familiale
    this.GetFileData(this.DescIdStatutParentTuteur, true).then((response) => {
      // Succès
      if (response.data) {
        this.StatutParentTuteur = response.data;
        this.StatutParentTuteurAffiche = response.data;
      }
    });

    // Nature du handicap
    this.GetFileData(this.DescIdNatureHandicap, true).then((response) => {
      // Succès
      if (response.data) {
        this.NatureHandicap = response.data;
      }
    });

    // Province
    this.GetFileData(this.DescIdProvince, true).then((response) => {
      // Succès
      if (response.data) {
        this.Province = response.data;
      }
    });

    // region
    this.GetFileData(this.DescIdRegion, true).then((response) => {
      // Succès
      if (response.data) {
        this.Region = response.data;
      }
    });

    // Departement
    this.GetFileData(this.DescIdDepartementFrance, true).then((response) => {
      // Succès
      if (response.data) {
        this.DepartementFrance = response.data;
      }
    });

    // Region
    this.GetFileData(this.DescIdRegionFrance, true).then((response) => {
      // Succès
      if (response.data) {
        this.RegionFrance = response.data;
      }
    });

    // etes vous
    this.GetFileData(this.DescIdEtesVous, true).then((response) => {
      if (response.data) {
        this.EtesVous = response.data;
      }
    });

    // Charge parent
    this.GetFileData(this.DescIdChargeParent, true).then((response) => {
      if (response.data) {
        this.ChargeParent = response.data;
      }
    });
    // Parent tuteur veuf/divorce
    this.GetFileData(this.DescIdSituationParent, true).then((response) => {
      if (response.data) {
        this.SituationParent = response.data;
      }
    });
    // vous etes
    this.GetFileData(this.DescIdVousEtes, true).then((response) => {
      if (response.data) {
        this.VousEtes = response.data;
      }
    });

    // connaissance firsi
    this.GetFileData(this.DescIdConnaissanceFirsi, true).then((response) => {
      if (response.data) {
        this.ConnaissanceFirsi = response.data.sort(this.DynamicSort("code"));
      }
    });

    // nb compte bancaire
    this.GetFileData(this.DescIdNbCompteBancaire, true).then((response) => {
      if (response.data) {
        this.NbCompteBancaire = response.data.sort(this.DynamicSort("code"));
      }
    });
    // Civilité
    this.GetFileData(this.DescIdCivilite, true).then((response) => {
      // Succès
      if (response.data) {
        this.Civilite = response.data;
      }
    });

    // lien parental
    this.GetFileData(this.DescIdParente, true).then((response) => {
      // Succès
      if (response.data) {
        this.Parente = response.data;
      }
    });
    // etat professionnel
    this.GetFileData(this.DescIdSecteur, true).then((response) => {
      // Succès
      if (response.data) {
        this.Secteur = response.data;
      }
    });

    // Situation pro
    this.GetFileData(this.DescIdSituationPro, true).then((response) => {
      // Succès
      if (response.data) {
        this.SituationPro = response.data;
      }
    });
    // type financement
    this.GetFileData(this.DescIdTypeFinancement, true).then((response) => {
      if (response.data) {
        this.TypeFinancement = response.data;
      }
    });
    // nature du bien
    this.GetFileData(this.DescIdNatureBien, true).then((response) => {
      if (response.data) {
        this.NatureBien = response.data;
      }
    });
    // Situation familiale
    this.GetFileData(this.DescIdSituationFamiliale, true).then((response) => {
      if (response.data) {
        this.SituationFamiliale = response.data;
      }
    });
  }
};
